document.addEventListener('DOMContentLoaded', (event) => {

    // Select the SVG within the div with ID "stadium"
    const stadiumSvg = document.querySelector('#stadium svg');

    // Get the total_donated variable from the window
    const totalDonated = window.php_data.total_donated;
    const donationGoal = window.php_data.donation_goal;
    // const totalDonated = 880000;

    // Calculate the donation percentage
    const amountPerSection = donationGoal / 48;

    // Calculate the section to highlight based on the amount donated
    const sectionToHighlight = Math.floor(totalDonated / amountPerSection) - 1;
    const donationPercentage = (totalDonated / donationGoal) * 100;
    const loaderFull = document.querySelector('.loader__full');
    loaderFull.style.width = `${donationPercentage}%`;
    // Apply a linear gradient to the sections
    const seats = document.getElementById("seats_no");
    const money = document.getElementById("money_no");
    const moneyAmount = document.getElementById("money_no").textContent;
    const seatsAmount = document.getElementById("seats_no").textContent;

    animateValue(money, 0, moneyAmount, 1000, true, '$');
    animateValue(seats, 0, seatsAmount, 1000, true);

    const delayPerSection = 1000/sectionToHighlight;
    for (let i = 0; i <= sectionToHighlight; i++) {
        const section = stadiumSvg.querySelector(`#section_${i}`);
        setTimeout(() => {
            // Apply the existing gradient to the section
            section.style.fill = `url(#linearGradient-${i})`;
        }, (i * delayPerSection)); // Change the delay time as needed
    }

    console.log('shmmm', 'ready')
        var validationContainer = jQuery('#gform_4_validation_container');
        console.log('shmmm', validationContainer)
        setTimeout(function() {
            console.log('shmmm', 'timeout')
            if (validationContainer.length) {
                console.log('shmmm', "loaded");
                console.log('shmmm', 'offset top: ', validationContainer.offset());
                jQuery('html, body').animate({
                    scrollTop: validationContainer.offset().top
                }, 'slow');
            }
    }, 1500);
});

function animateValue(obj, start, end, duration, includePunctuation, prefix = '') {
    const easeOutQuad = (t) => t * (2 - t);
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const easedProgress = easeOutQuad(progress);
        const value = Math.floor(easedProgress * (end - start) + start);
        obj.innerHTML = prefix + '' + (includePunctuation ? numberWithCommas(value) : value);
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

function numberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
